import { abortableFetch, DetailContext } from '@eas/common-web';
import { EvidenceApiUrl } from '@enums';
import { useContext } from 'react';

export function useReimportDialog() {
  const { source } = useContext(DetailContext);

  const dataSourceId = source.data?.id;
  const dataSourceName = source.data?.name;

  const callApi = () => {
    return abortableFetch(`${EvidenceApiUrl.IMPORT_REQUEST}`, {
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      method: 'POST',
      body: JSON.stringify({
        incremental: false,
        source: { id: dataSourceId },
      }),
    });
  };

  const showButton = true;

  return { callApi, showButton, dataSourceName };
}
